import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/logo.png'


const _hoisted_1 = { class: "v1-lmd-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "custom-row" }
const _hoisted_4 = { class: "site-logo" }
const _hoisted_5 = { class: "v1-lmd-hdr-right" }
const _hoisted_6 = { class: "header-login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            id: "siteLogo",
            to: '/employee/dashboard'
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "v1-button-outline",
              id: "loginLink",
              to: '/employee/login'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.constants.LOGIN_BUTTON), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}